import { darkColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledNetworks = styled.div`
  color: ${({ theme }) => theme.colors.white};
  margin-bottom: 3rem;
  position: relative;
  border-radius: ${({ theme }) => theme.radius.small};
  background-color: rgb(18, 18, 18);
  canvas {
    background: ${({ theme }) => theme.colors.black};
    height: 54rem;
    width: 100%;
  }
`;

export const StyledControls = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.colors.background.disabled};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-bottom-left-radius: ${({ theme }) => theme.radius.small};
  border-bottom-right-radius: ${({ theme }) => theme.radius.small};
  display: flex;
  justify-content: space-between;
  padding: 1rem 1.8rem;

  & > div {
    width: max-content;
  }

  p {
    color: ${({ theme }) => theme.colors.text.main};
  }
`;

export const StyledWrapperButton = styled.div`
  position: relative;

  &:hover {
    & > div[data-wrapper='tooltip'] {
      visibility: visible;
    }
  }
`;

export const StyledTooltip = styled.div`
  top: 4.2rem;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  width: 16.5rem;
  text-align: center;
  visibility: hidden;

  @media screen and (max-width: 1330px) and (min-width: ${({ theme }) => theme.sizes.lg}) {
    &[data-tooltip='first'] {
      left: 62%;
    }
  }
`;

export const StyledNetworkState = styled.p`
  position: absolute;
  top: 1rem;
  right: 1rem;

  span {
    &[data-state='running'] {
      color: ${darkColors.success.main};
    }

    &[data-state='stopped'] {
      color: ${darkColors.error.main};
    }

    &[data-state='resetting'] {
      color: ${darkColors.warning.main};
    }
  }
`;

export const StyledNetworkTime = styled.p`
  font-size: 1.8rem;
`;
